import { render, staticRenderFns } from "./CustomerDetailEmpty.vue?vue&type=template&id=74356123"
import script from "./CustomerDetailEmpty.vue?vue&type=script&lang=js"
export * from "./CustomerDetailEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports